import { cardListWrapper } from './styles.css'

type Props = {
  children: React.ReactNode
}

export const CardListWrapper: React.FC<Props> = ({ children }) => {
  return <div className={cardListWrapper}> {children} </div>
}
